import React from "react";

import { useForm } from "react-hook-form";

import type { CalendarItemTypeSelectFragment } from "../../../components/controllers/CalendarItemTypeSelect/CalendarItemTypeSelect-generated.hooks";
import type { StaffProfileSelectFragment } from "../../../components/controllers/StaffProfileSelect/StaffProfilesSelect-generated.hooks";

import { Grid, Button } from "@pushpress/shared-components";
import CalendarItemTypeController from "../../../components/controllers/CalendarItemTypeSelect";
import StaffProfileSelect from "../../../components/controllers/StaffProfileSelect";
import { CalendarItemSessionTypes } from "../Calendar.utils";

export interface CalendarItemsListFilterValue {
  types: CalendarItemTypeSelectFragment[];
  staff: StaffProfileSelectFragment[];
}

interface CalendarItemsListFilterProps {
  filter: CalendarItemsListFilterValue;
  calendarItemType: CalendarItemSessionTypes;
  onFilterChange: (filter: CalendarItemsListFilterValue) => void;
  onClear: VoidFunction;
}

function CalendarItemsListFilter(props: CalendarItemsListFilterProps) {
  const { filter, calendarItemType, onFilterChange, onClear } = props;

  const { control, handleSubmit } = useForm<CalendarItemsListFilterValue>({
    defaultValues: filter,
  });

  return (
    <form
      noValidate
      onSubmit={handleSubmit(onFilterChange)}
      style={{ padding: 20, width: 300 }}
    >
      {calendarItemType === CalendarItemSessionTypes.Classes && (
        <CalendarItemTypeController
          isMulti
          name="types"
          label="Type"
          control={control}
          isClearable
          hideDropdownIndicator
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
        />
      )}
      <StaffProfileSelect
        isMulti
        name="staff"
        label="Staff"
        control={control}
        isClearable
        hideDropdownIndicator
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
      />

      <Grid container justifyContent="flex-end">
        <Grid item>
          <Button
            text="Clear"
            buttonType="secondary"
            type="button"
            onClick={onClear}
          />
        </Grid>
        <Grid item>
          <Button text="Apply" buttonType="primary" type="submit" />
        </Grid>
      </Grid>
    </form>
  );
}

export default CalendarItemsListFilter;
